/* age-eq.v4.js — fixed peak at 25 years, no forced autofill while typing */
(function(){
  var NEUTRAL_AGE = 25; // fast baseline

  function initAgeEqCalculator(root){
    if (!root) return;
    var distanceEl = root.querySelector('[data-age-eq="distance"]');
    var ageEl      = root.querySelector('[data-age-eq="age"]');
    var timeEl     = root.querySelector('[data-age-eq="time"]');
    var tableBody  = root.querySelector('[data-age-eq="tbody"]');
    var errorEl    = root.querySelector('[data-age-eq="error"]') || root.querySelector('#error');

    // ---- Age degradation (>= 25) & youth penalty (< 25)
    var kOldByDistance = { '1500':0.0045,'mile':0.0048,'5000':0.0050,'10000':0.0052,'21097':0.0053,'42195':0.0058 };
    var kYoungPenaltyByDistance = { '1500':0.0025,'mile':0.0028,'5000':0.0033,'10000':0.0036,'21097':0.0040,'42195':0.0043 };

    function lateAgeAsym(age){
      if (age >= 75) return 1.10;
      if (age >= 65) return 1.05;
      if (age >= 60) return 1.03;
      return 1.00;
    }

    // Faktor ≥ 1, minimum ved 25 år (peak)
    function ageFactor(age, distKey){
      var a = Math.max(15, Math.min(100, parseInt(age,10) || NEUTRAL_AGE));
      var kOld   = kOldByDistance[distKey]          || 0.0052;
      var kYoung = kYoungPenaltyByDistance[distKey] || 0.0036;
      if (a === NEUTRAL_AGE) return 1.0;
      if (a >    NEUTRAL_AGE) return Math.exp((a - NEUTRAL_AGE) * kOld) * lateAgeAsym(a);
      return Math.exp((NEUTRAL_AGE - a) * kYoung); // yngre => lidt langsommere end 25
    }

    // -------- Utils --------
    function parseTimeToSeconds(s){
      if (!s) return NaN;
      s = (''+s).trim().replace(/,/g,'.');
      var p = s.split(':'), h=0,m=0,sec=0;
      if (p.length===1){ sec=parseFloat(p[0]); return isNaN(sec)?NaN:sec; }
      if (p.length===2){ m=parseInt(p[0],10); sec=parseFloat(p[1]); }
      else if (p.length===3){ h=parseInt(p[0],10); m=parseInt(p[1],10); sec=parseFloat(p[2]); }
      else return NaN;
      if ([h,m,sec].some(function(v){ return isNaN(v) || v<0; })) return NaN;
      return h*3600 + m*60 + sec;
    }
    function formatSeconds(totalSeconds){
      if (!isFinite(totalSeconds) || totalSeconds <= 0) return '—';
      var s = Math.round(totalSeconds*100)/100;
      var h = Math.floor(s/3600); s -= h*3600;
      var m = Math.floor(s/60);   var sec = s - m*60;
      var secStr = (sec<10?'0':'') + sec.toFixed(sec%1===0?0:2);
      var mStr   = (m<10?'0':'') + m;
      return (h>0? h+':' : '') + mStr + ':' + secStr;
    }

    // Sæt defaults kun én gang ved load – ikke mens man taster
    var initializedDefaults = false;
    function ensureDefaultsOnce(){
      if (initializedDefaults) return;
      if (ageEl && !ageEl.value && ageEl.placeholder)  ageEl.value  = ageEl.placeholder;
      if (timeEl && !timeEl.value && timeEl.placeholder) timeEl.value = timeEl.placeholder;
      initializedDefaults = true;
    }

    function recompute(){
      if (errorEl)  errorEl.textContent = '';
      if (tableBody) tableBody.innerHTML = '';

      // Lad brugeren tømme felter uden at vi autoudfylder
      var ageStr  = ageEl  ? (''+ageEl.value).trim()  : '';
      var timeStr = timeEl ? (''+timeEl.value).trim() : '';

      if (!ageStr || !timeStr) {
        // bare vis ingenting mens der tastes/slettes
        return;
      }

      var age  = parseInt(ageStr, 10);
      var t    = parseTimeToSeconds(timeStr);
      var dist = distanceEl && distanceEl.value;

      if (isNaN(age) || age < 15 || age > 90) { if (errorEl) errorEl.textContent='Angiv en alder mellem 15 og 90 år.'; return; }
      if (isNaN(t)   || t <= 0)               { if (errorEl) errorEl.textContent='Angiv en gyldig tid (fx 40:30 eller 1:12:05).'; return; }

      // Konverter til 25-års baseline
      var T25 = t / ageFactor(age, dist);

      // Render tabellen (25 år vil være hurtigst)
      var frag = document.createDocumentFragment();
      for (var a=15; a<=90; a++){
        var eqTime = T25 * ageFactor(a, dist);
        var diff   = eqTime - t;

        var tr=document.createElement('tr');
        var tdA=document.createElement('td'); tdA.textContent = a + ' år';
        var tdT=document.createElement('td'); tdT.textContent = formatSeconds(eqTime);
        var tdD=document.createElement('td');
        var sign = diff===0? '' : (diff>0? '+' : '−');
        tdD.textContent = sign + formatSeconds(Math.abs(diff));
        tr.appendChild(tdA); tr.appendChild(tdT); tr.appendChild(tdD);

        if (a === age){ tr.style.background='#fff9e6'; tr.style.fontWeight='bold'; }
        frag.appendChild(tr);
      }
      if (tableBody) tableBody.appendChild(frag);
    }

    var deb; function debounced(){ clearTimeout(deb); deb=setTimeout(recompute,80); }
    if (distanceEl) distanceEl.addEventListener('change', recompute);
    if (ageEl)      ageEl.addEventListener('input', debounced);
    if (timeEl)     timeEl.addEventListener('input', debounced);

    ensureDefaultsOnce();   // kun ved load
    recompute();            // første render
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-age-eq-root]').forEach(initAgeEqCalculator);
  });
})();
